import { Link } from 'react-router-dom';

import { useIdioma } from '../../context/IdiomaContext';

import './ServiciosInicio.css';

function ServiciosInicio() {
  const { t } = useIdioma();

  return (
    <section
      id="servicios-inicio"
      className="servicios-inicio"
    >
      <h2>
        {t('serviciosInicio.titulo')}
      </h2>

      <div className="servicios-inicio-container">
        <Link
          to="/servicios#coaching"
          className="servicio-card"
        >
          <h3>
            {t(
              'serviciosInicio.coaching.titulo'
            )}
          </h3>

          <p>
            {t(
              'serviciosInicio.coaching.descripcion'
            )}
          </p>

          <span>
            {t('serviciosInicio.saberMas')} →
          </span>
        </Link>

        <Link
          to="/servicios#facilitacion"
          className="servicio-card"
        >
          <h3>
            {t(
              'serviciosInicio.facilitacion.titulo'
            )}
          </h3>

          <p>
            {t(
              'serviciosInicio.facilitacion.descripcion'
            )}
          </p>

          <span>
            {t('serviciosInicio.saberMas')} →
          </span>
        </Link>

        <Link
          to="/servicios#cambio-sistemico"
          className="servicio-card"
        >
          <h3>
            {t(
              'serviciosInicio.cambio.titulo'
            )}
          </h3>

          <p>
            {t(
              'serviciosInicio.cambio.descripcion'
            )}
          </p>

          <span>
            {t('serviciosInicio.saberMas')} →
          </span>
        </Link>
      </div>
    </section>
  );
}

export default ServiciosInicio;